import React from 'react'
import Modal from 'react-bootstrap/Modal';
import { Form, Button, Container, Dropdown, Spinner } from 'react-bootstrap';

const EmployeeValidationModalResult = ({show,handleClose,requestState,handleConfirmCloseModal, networkError, handleEmployeeFormModalCloseValidRetry}) => {
  return (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>
                    {requestState ? "Congratulations! Discount Applied" : "Failed to Apply Discounted Plan"}
                    {networkError ? "Network problem please try again later" : null}
                    </Modal.Title>
            </Modal.Header>
            <Modal.Body>
          
                     {
                        requestState ? <p style={{padding:'1em 0'}}>
                            Congratulations! Your Unibanker code has been verified successfully. You can now use the discounted plan.
                        </p> : <p style={{padding:'1em 0'}}> We're sorry, but the requested Unibanker record does not exist. As a result, the success discount could not be applied.</p>
                     }

                    {networkError ? " We are unable to verify the Unibanker code due to a network connectivity issue. Please check your internet connection and try again." : null}
                   
           
            </Modal.Body>
            <Modal.Footer>
                  {
                    requestState ? 

                      <Button
                                   variant="primary"
                                   style={{
                                       background: '#f2d841',
                                       color: 'black',
                                       border: 'none',
                                       fontFamily: 'Montserrat, sans-serif',
                                       padding: '10px 15px'
                                   }}

                             onClick={handleConfirmCloseModal}
                         >
                             Confirm
                         </Button>

                         :
                         (
                            <>
                                 <Button
                                   variant="primary"
                                   style={{
                                       background: '#f2d841',
                                       color: 'black',
                                       border: 'none',
                                       fontFamily: 'Montserrat, sans-serif'
                                   }}

                             onClick={handleEmployeeFormModalCloseValidRetry}
                         >
                              Retry
                         </Button>

                               <Button variant="secondary" onClick={handleClose}>
                               Close
                          </Button>

                         </>
                         
                         )
                    

                    
                      
                  }
            </Modal.Footer>
        </Modal>
  )
}

export default EmployeeValidationModalResult